import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('[supabase] VITE_SUPABASE_URL veya VITE_SUPABASE_ANON_KEY eksik. Yerel yedek mod devrede.');
}

// Boş veya eksik değerlerde uygulamanın tamamen çökmesini (beyaz ekran) engellemek için fallback kullanıyoruz
const safeUrl = supabaseUrl || 'https://placeholder-url.supabase.co';
const safeKey = supabaseAnonKey || 'placeholder-anon-key';

// Clerk global instance'ı (@clerk/clerk-js) window'a kendini ekler ama tip tanımı paylaşmaz.
type ClerkWindow = Window & {
  Clerk?: { session?: { getToken: () => Promise<string | null> } };
};

// Clerk oturum token'ını Supabase isteklerine ekler — RLS politikalarının auth.jwt() ile
// gerçek kullanıcı kimliğini görebilmesi için gerekli (Supabase Dashboard > Third Party Auth > Clerk
// entegrasyonu aktif olmalı). window.Clerk, ClerkProvider mount olduktan sonra kullanılabilir hale gelir.
export const supabase = createClient(safeUrl, safeKey, {
  accessToken: async () => {
    try {
      return (await (window as ClerkWindow).Clerk?.session?.getToken()) ?? null;
    } catch {
      return null;
    }
  },
});
